<template>
  <div>
    <b-card>
      <b-row>
        <b-col sm="4">
          <b-form-group label="Tipo">
            <input-select
              v-model="model.codigoMsg"
              placeholder="Todos"
              :options="arrayTipoArquivoCCS"
              single
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Situação Solicitação">
            <input-select
              v-model="model.situacao"
              :options="$api.Arrays.SituacaoSolicitacaoCCS"
              single
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Situação Informação">
            <input-select
              v-model="model.situacaoInformacao"
              placeholder="Todos"
              :options="optionsDinamico"
              single
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-form-group label="Retorno BACEN">
            <input-select
              v-model="model.situacaoRetorno"
              placeholder="Todos"
              :options="$api.Arrays.SituacaoRetornoCCS"
              single
            />
          </b-form-group>
        </b-col>
        <!-- data inicial -->
        <b-col sm="3">
          <b-form-group :label="dtIniText">
            <kendo-datepicker
              v-model="model.datainicial"
              :max="dtMax"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
              :required="requiredData"
            ></kendo-datepicker>
          </b-form-group>
        </b-col>

        <!-- data final -->
        <b-col sm="3">
          <b-form-group :label="dtFimText">
            <kendo-datepicker
              v-model="model.datafinal"
              :min="dtMin"
              v-mask="'##/##/####'"
              :format="'dd/MM/yyyy'"
              :required="requiredData"
            ></kendo-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object },
    dtIniText: { type: String, default: 'Data Inclusão Inicial' },
    dtFimText: { type: String, default: 'Data Inclusão Final' },
    requiredData: { type: Boolean, default: true }
  },
  data() {
    return {
      situacao: [],
      datainicial: '',
      datafinal: '',
      codigoMsg: [],
      situacaoInformacao: [],
      situacaoRetorno: [],
      arrayTipoArquivoCCS: [
        { value: 1, text: 'Relacionamento de Pessoa (CCS0001)' },
        { value: 2, text: 'Pessoas Vinculadas a Conta (CCS0003)' }
      ],
      SituacaoInformacaoCCSPessoa: [
        { value: 1, text: 'Não Informar' },
        { value: 2, text: 'Informar' },
        { value: 3, text: 'Liminar' }
      ],
      SituacaoInformacaoCCSConta: [
        { value: 4, text: 'Relacionamento Inexistente' },
        { value: 5, text: 'Conta Ativa' },
        { value: 6, text: 'Conta Inexistente' },
        { value: 7, text: 'Conta Encerrada' },
        { value: 8, text: 'Conta sob Liminar' }
      ]
    }
  },
  computed: {
    dtMin: function () {
      return this.model.datainicial
        ? kendo.parseDate(this.model.datainicial)
        : new Date('1970-01-01Z00:00:00:000')
    },
    dtMax: function () {
      return this.model.datafinal
        ? kendo.parseDate(this.model.datafinal)
        : new Date()
    },
    model: {
      get() {
        var obj = this.value
        return obj
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    optionsDinamico() {
      if (this.model.codigoMsg === 1) {
        return this.SituacaoInformacaoCCSPessoa
      } else if (this.model.codigoMsg === 2) {
        return this.SituacaoInformacaoCCSConta
      } else {
        return this.$api.Arrays.SituacaoInformacaoCCS
      }
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh')
    },
  }
}
</script>